/** Tiny event bus so any component can react to a scanned barcode / wristband. */
const bus = new EventTarget();

export function emitScan(code: string): void {
  bus.dispatchEvent(new CustomEvent("scan", { detail: code }));
}

export function onScan(handler: (code: string) => void): () => void {
  const fn = (e: Event) => handler((e as CustomEvent<string>).detail);
  bus.addEventListener("scan", fn);
  return () => bus.removeEventListener("scan", fn);
}
